import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useHistory } from 'react-router-dom';

// "Warm 404" per prototype — terra Instrument Serif "404.", soft copy,
// two CTAs. The kindest dead-end page on the internet.
const NotFoundPage: React.FC = () => {
  const history = useHistory();
  return (
    <IonPage>
      <IonContent>
        <div className="fhv2-mpage" style={{
          minHeight: '100vh',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          textAlign: 'center', padding: 'calc(32px + env(safe-area-inset-top, 0px)) 24px 32px',
          backgroundImage: 'radial-gradient(ellipse at 30% 20%, rgba(197,81,45,0.18), transparent 55%)',
        }}>
          <div style={{ fontFamily: 'var(--fhv2-serif)', fontStyle: 'italic', fontSize: 140, lineHeight: 0.85, color: 'var(--fhv2-terra)', letterSpacing: '-0.04em' }}>
            404.
          </div>
          <div style={{ fontFamily: 'var(--fhv2-mono)', fontSize: 10, letterSpacing: '2px', color: 'var(--fhv2-muted)', margin: '14px 0 16px', textTransform: 'uppercase' }}>
            PAGE NOT FOUND
          </div>
          <h2 style={{ fontSize: 26, lineHeight: 1.1, margin: '0 0 12px', color: '#fff', fontFamily: 'var(--fhv2-sans)' }}>
            <em style={{ color: 'var(--fhv2-terra)', fontFamily: 'var(--fhv2-serif)', fontStyle: 'italic' }}>Not here.</em><br/>No harm done.
          </h2>
          <p style={{ color: 'var(--fhv2-muted)', fontSize: 13, lineHeight: 1.55, maxWidth: 280, margin: '0 0 22px' }}>
            Either we moved it, you mistyped, or a link went stale.
          </p>
          <button
            onClick={() => history.push('/app/home')}
            className="fhv2-btn is-primary"
            style={{ width: '100%', maxWidth: 320, padding: 14, justifyContent: 'center', marginBottom: 8 }}
          >
            Take me home
          </button>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NotFoundPage;
